import React, { Fragment } from 'react';
import SiteFlashes from 'containers/SiteFlashes';
import PageHeader, { ActionDef } from 'components/general/PageHeader/PageHeader';
import PageHeaderSkeleton from 'components/general/PageHeader/PageHeaderSkeleton';
import LinkProps from 'utils/ts/LinkProps';
import renderLoadState from 'utils/renderLoadState';
import loadingStateType from 'utils/ts/LoadingStateType';

const AccountLayout: React.SFC<PropDef> = ({
  title,
  section, 
  action,
  loading,
  children,
}) => (
  <Fragment>
    <div className="l-sub-page__header">
      {renderLoadState({
        LOADING: () => <PageHeaderSkeleton />,
        SUCCESS: () => (
          <PageHeader
            title={title}
            section={section}
            actions={action}
          />
        ),
      })(loading)}
    </div>

    <main className="l-sub-page__main">
      <SiteFlashes />
      {children}
    </main>
  </Fragment>
);

AccountLayout.defaultProps = {
  loading: {
    state: 'SUCCESS',
    errors: [],
  },
};

const AccountLayoutSection = ({ children }) => (
  <section className="l-sub-page__area">
    {children}
  </section>
);

// @todo: How to deal with this + TS?
AccountLayout.Section = AccountLayoutSection;

interface PropDef {
  title: string;
  loading?: loadingStateType;
  section?: {
    title: string;
    to?: LinkProps;
  };
  action?: ActionDef[];
}

export default AccountLayout;
